import { useState, useEffect } from "react";
import { BoardProvider } from "./context";
import Board from "./components/Board";
import { Login } from "./components/Login";
import { auth } from "./pocketbase";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    setIsAuthenticated(auth.isAuthenticated());
  }, []);

  if (!isAuthenticated) {
    return <Login onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <BoardProvider>
      <Board />
    </BoardProvider>
  );
}

export default App;
